/**
 * @desc 修改管理域
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.ModifyTheManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/base/update',
    data,
  });
}

export function mock(
  data: defs.ModifyTheManagementDomainParameters,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/base/update',
    data,
  });
}
